import type {
  ArticleHeroMediaAlign,
  ArticleHeroMediaSize,
  ArticleHeroMediaVerticalAlign,
} from '../../../shared/domain/articleHeroMedia';

const MODULE = 'articleHeroMedia';

export function logArticleHeroMediaLayout(
  operation: string,
  context: {
    kind: 'image' | 'video' | 'demo';
    size: ArticleHeroMediaSize;
    align: ArticleHeroMediaAlign;
    verticalAlign: ArticleHeroMediaVerticalAlign;
    scale: number;
    viewportWidth?: number;
    viewportHeight?: number;
    naturalWidth?: number;
    naturalHeight?: number;
  },
): void {
  console.debug(`[debug] [${MODULE}:${operation}]`, JSON.stringify(context));
}
